import {
    PagingBaseComponent,
    PagingBaseProps,
    PagingBaseState,
    Page,
    HasId,
} from "./PagingBaseComponent";

export default PagingBaseComponent;
export {
    PagingBaseProps,
    PagingBaseState,
    Page,
    HasId,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PagingBaseComponent/index.tsx